import React, { useState } from 'react';
import { MapPin, Phone } from 'lucide-react';
import { Button } from './Button';
import { Checkbox } from './Checkbox';
export function ContactSection() {
  const [consent, setConsent] = useState(false);
  return <section className="py-16 sm:py-20 bg-background-body" id="contact" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-15">
          {/* Contact Info */}
          <div data-id="element-16">
            <h2 className="text-3xl font-heading text-text-title mb-6" data-id="element-17">
              Get in touch
            </h2>
            <p className="text-text-default mb-8 text-lg" data-id="element-18">
              Ready to find the right financial solution for your needs? Call me
              today or complete the form and I will call you.
            </p>

            <div className="space-y-6" data-id="element-19">
              <div className="flex items-start gap-4" data-id="element-20">
                <div className="bg-background-primary-light p-3 rounded-full text-text-primary-default" data-id="element-21">
                  <MapPin className="w-6 h-6" data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h3 className="font-body-semi-bold text-text-title text-lg" data-id="element-24">
                    Jerry Gibb – Coastline Mortgages
                  </h3>
                  <p className="text-text-default" data-id="element-25">
                    3 Alicante Mews
                    <br data-id="element-26" />
                    Secret Harbour, WA, 6173
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-27">
                <div className="bg-background-primary-light p-3 rounded-full text-text-primary-default" data-id="element-28">
                  <Phone className="w-6 h-6" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h3 className="font-body-semi-bold text-text-title text-lg" data-id="element-31">
                    Phone
                  </h3>
                  <p className="text-text-default mb-3" data-id="element-32">0408 247 276</p>
                  <a href="tel:0408247276" className="inline-block" data-id="element-33">
                    <Button variant="primary" className="flex items-center gap-2" data-id="element-34">
                      <Phone className="w-4 h-4" data-id="element-35" />
                      Call 0408 247 276
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-neutral-white p-8 rounded-xl shadow-sm border border-border-default" data-id="element-36">
            <h3 className="text-2xl font-heading text-text-title mb-6" data-id="element-37">
              Send a message
            </h3>
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-38">
              <div data-id="element-39">
                <label htmlFor="name" className="block text-sm font-body-semi-bold text-text-title mb-1" data-id="element-40">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-border-default focus:outline-none focus:ring-2 focus:ring-text-primary-default focus:border-transparent" placeholder="Your full name" data-id="element-41" />
              </div>

              <div data-id="element-42">
                <label htmlFor="phone" className="block text-sm font-body-semi-bold text-text-title mb-1" data-id="element-43">
                  Phone
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-border-default focus:outline-none focus:ring-2 focus:ring-text-primary-default focus:border-transparent" placeholder="Your phone number" data-id="element-44" />
              </div>

              <div data-id="element-45">
                <label htmlFor="email" className="block text-sm font-body-semi-bold text-text-title mb-1" data-id="element-46">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-border-default focus:outline-none focus:ring-2 focus:ring-text-primary-default focus:border-transparent" placeholder="Your email address" data-id="element-47" />
              </div>

              <div data-id="element-48">
                <label htmlFor="message" className="block text-sm font-body-semi-bold text-text-title mb-1" data-id="element-49">
                  Your message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-border-default focus:outline-none focus:ring-2 focus:ring-text-primary-default focus:border-transparent resize-none" placeholder="How can I help you?" data-id="element-50"></textarea>
              </div>

              <Checkbox checked={consent} onChange={e => setConsent(e.target.checked)} label="I agree to be contacted about my enquiry" caption="Your details are safe and will only be used to respond to your message." size="sm" data-id="element-51" />

              <div className="pt-2" data-id="element-52">
                <Button type="submit" variant="primary" size="lg" className="w-full" disabled={!consent} data-id="element-53">
                  Send message
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>;
}